import { createContext } from 'react';

import { ClientConfig } from 'configs/types';

export default createContext<ClientConfig>({
  firebase: {
    apiKey: '',
    authDomain: '',
    databaseURL: '',
    projectId: '',
    storageBucket: '',
    messagingSenderId: '',
    appId: '',
    measurementId: '',
  },
  ccm: {
    URL: '',
  },
  duckyFeedbackSurvey: {
    no: '',
    en: '',
    es: '',
    ja: '',
  },
  cloudFunctionUrl: '',
  cloudFunctionRegion: '',
  widgetUrl: '',
  appUrl: '',
  domain: '',
  staticUrl: '',
  translateImagePath: '',
  DUCKY_ENV: '',
  duckyApi: {
    url: '',
    firebaseUrl: '',
  },
});
